module.exports = __webpack_public_path__ + "img/selected3-min.c160f338.png";